import React from "react";
import ModalList from './../../components/ModalList';
import DragDrop from "./../../components/DragDrop";

const HomePage = () => {
  return (
    <>
      <div className="container">
        Home
        <ModalList />
        <DragDrop />
      </div>
    </>
  );
};

export default HomePage;